// extracted by mini-css-extract-plugin
export default {"page":"StripeReturn_page__JvMqS","card":"StripeReturn_card__B-UG4","icon":"StripeReturn_icon__A+Z5c","title":"StripeReturn_title__Uq3DK","text":"StripeReturn_text__1TnJ0"};